
<template>
    <div style="width: 100%; display:block; float:left; clear:both;">

        <div class="row">
            <h3>Your Plan</h3>
            <p class="mb-0 italic"><img src="/images/SwingUPremiumLogoGreen.png" alt="SwingU Premium" width="120px" style="vertical-align: middle;"> (Added by Admin)</p>
        </div>

        <div class="row mt-20">
            <h3 class="mb-10">Renewal</h3>
            <p class="mb-0">Your membership ends {{ viewModel.renewalDate }} ({{ viewModel.renewalDays }} days left)</p>
        </div>

        <div class="row footer-message-wrapper">
            <hr>
            <p class="mt-20 mb-0">We're here to help. No matter what the issue, don't hesitate to ask. Visit our support site at <a href="https://help.swingu.com" target="_blank">help.swingu.com</a> or email us at <a href="mailto:support@swingu.com" target="_blank">support@swingu.com</a>.</p>
        </div>
    </div>
</template>

<script>
import axios, { Method } from "axios";

export default {
    props: ['paymentDetails', 'paymentMethods', 'viewModel', 'stripePublicKey'],

    data: () => {
        return {
            setupIntent: '',
            debugMessages: [
                'Waiting...',
            ],
            stripe: {},
            cardElement: {},
            changingCard: false,
            stipeElementsMounted: false,
            existingCardNumber: '',
            existingCardExpiry: '',
        };
    },

    created: function() {
        this.debug('we hit here');
        this.debug(this.paymentDetails);
        this.debug(this.paymentMethods);

        this.bindExistingCardData(this.viewModel.paymentMethods[0]);
    },

    methods: {
        addNewCard: function () {
            this.debug('Sending to stripe...');

            this.changingCard = true;
            this.stipeElementsMounted = false;
            this.getSetupIntent();
        },

        getSetupIntent: function () {
            var self = this;

            axios.get('/account/subscription/get-payment-intent', {

            }).then((response) => {
                self.debug('We received a SUCCESS response');
                self.debug(response.data);
                self.setupIntent = response.data;
                self.triggerStripeElements();
            }, (error) => {
                self.debug('We received an ERROR response');
                self.debug(error);
            });
        },

        triggerStripeElements: function () {
            this.stripe = Stripe(this.stripePublicKey);
            let elements = this.stripe.elements();
            this.cardElement = elements.create('card');
            this.cardElement.mount('#card-element');
            this.stipeElementsMounted = true;
        },

        saveCardDetails: function () {
            this.debug('Saving card details...');

            var self = this;

            this.setupCardInStripeAndAttachToCustomer();

            // this.stripe.confirmCardSetup(self.setupIntent.client_secret, {
            //         payment_method: {
            //             card: self.cardElement,
            //             billing_details: {
            //                 name: 'John Smith',
            //             }
            //         },
            // }).then(function (result) {
            //     if (result.error) {
            //         self.debug(result.error.message);
            //     } else {
            //         self.debug('Setup succeeded');
            //         self.debug('Setup Intent Payment Method: ' + result.setupIntent.payment_method);
            //     }
            // });
        },

        setupCardInStripeAndAttachToCustomer: function () {
            var self = this;

            this.stripe.confirmCardSetup(self.setupIntent.client_secret, {
                payment_method: {
                    card: self.cardElement,
                    billing_details: {
                        name: 'John Smith',
                    }
                },
            }).then(function (result) {
                if (result.error) {
                    self.debug(result.error.message);
                } else {
                    self.debug('Setup succeeded');
                    self.debug('Setup Intent Payment Method: ' + result.setupIntent.payment_method);
                    self.debug('Setup Intent: ' + result.setupIntent);
                    self.attachPaymentMethodToCustomerInStripe(result.setupIntent.payment_method);
                }
            });

        },

        attachPaymentMethodToCustomerInStripe: function (paymentMethodId) {
            var self = this;
            axios.post('/account/subscription/update-customer-card-details', {
                paymentMethodId: paymentMethodId
            }).then((response) => {
                self.debug(response.data);
                self.bindExistingCardData(response.data.card);
                self.changingCard = false;
            }, (error) => {
                self.debug('We received an ERROR response');
                self.debug(error);
            });
        },

        setDefaultPaymentMethod: function (paymentMethodId) {
            this.debug('Setting default payment method to: ' + paymentMethodId);

            var self = this;

            let confirmation = confirm('Are you sure?');

            if (!confirmation) {
                console.log('we declined. Exited.');
                return false;
            }

            axios.post('/account/subscription/set-default-payment-method', {
                paymentMethodId: paymentMethodId
            }).then((response) => {
                self.debug('We have changed the default card');

                var existingRowIndex = self.paymentMethods.findIndex(function (o) {
                    return o.default == true;
                });

                var newRowIndex = self.paymentMethods.findIndex(function (o) {
                    return o.id == paymentMethodId;
                });

                if (existingRowIndex == -1 || newRowIndex == -1) {
                    return false;
                }

                self.paymentMethods[existingRowIndex].default = false;
                self.paymentMethods[newRowIndex].default = true;
            }, (error) => {
                self.debug('We received an ERROR response');
                self.debug(error);
            });
        },

        removePaymentMethod: function (paymentMethodId) {
            this.debug('Deleting payment method: ' + paymentMethodId);

            var self = this;

            let confirmation = confirm('Are you sure?');

            if (!confirmation) {
                console.log('we declined. Exited.');
                return false;
            }

            axios.delete('/account/subscription/delete-customer-card/' + paymentMethodId)
            .then((response) => {
                self.debug('We have deleted the card');

                var rowIndex = self.paymentMethods.findIndex(function (o) {
                    return o.id == paymentMethodId;
                });

                if (rowIndex == -1) {
                    return false;
                }

                self.paymentMethods.splice(rowIndex, 1);
            }, (error) => {
                self.debug('We received an ERROR response');
                self.debug(error);
            });
        },

        cancelChangeCard: function () {
            this.changingCard = false;
        },

        bindExistingCardData: function (card) {
            if (card) {
                this.existingCardNumber = card.last4;

                let expiry = (card.expiry) ? card.expiry : this.buildExpiryDate(card.exp_month, card.exp_year);

                this.existingCardExpiry = expiry;
            }
        },

        buildExpiryDate: function (expiryMonth, expiryYear) {
            return this.leftPadNumber(expiryMonth, 2) + '/' + this.leftPadNumber(expiryYear, 2);
        },

        leftPadNumber: function (number, targetLength) {
            while (number.length < targetLength) {
                number = '0' + number;
            }

            return number;
        },

        debug: function (message) {
            // console.log('DEBUG: ', message);
            // this.debugMessages.push(message);
        }
    }
}
</script>


<style scoped lang="scss">
@import "@/_var.scss";
</style>
